
export namespace Filters {
    export function getNewStudyFilters(): StudyFilters {
        return {
            patientName: null,
            studyDescription: null,
            studyDate: null,
        //searchTerm: null,
            pageConfig: {
                pageNumber: null,
                pageSize: null,
                sort1: null,
                sort2: null,
                sort3: null,
                direction1: null,
                direction2: null,
                direction3: null,
            },
        }
    } 

}

export interface PageConfig {
    pageNumber: number | null;
    pageSize: number | null;
    sort1: string | null;
    sort2: string | null;
    sort3: string | null;
    direction1: string | null;
    direction2: string | null;
    direction3: string | null;
}

export interface StudyFilters {
    patientName: string | null;
    studyDescription: string | null;
    studyDate: string | null;
    //searchTerm: string | null;
    pageConfig: PageConfig;
    studyStatus?: string | null;
}